<template>
    <!-- Your Page Content Goes Here-->
    <div class="page-content header-clear-medium">

		<div v-show="!initial_send_otp" class="card card-style">
			<div class="text-center alert bg-green-light shadow-bg shadow-bg-m alert-dismissible rounded-s fade show mb-0" role="alert">
				<i class="bi bi-check-circle-fill pe-2"></i>
				<strong>OTP Telah Terkirim ke Whatsapp Anda</strong>
			</div>
		</div>

		<div class="card card-style">
			<div class="content">
                <h1 class="text-center font-800 font-22 mb-2 color-blue-dark">Selamat Datang di aplikasi PARENTAL</h1>

				<div v-show="initial_send_otp" class="card card-style bg-fade-blue border border-fade-blue alert alert-dismissible show fade p-0 mb-3">
					<div class="content my-3">
						<div class="d-flex">
							<div class="align-self-center">
								<i class="bi bi-info-square font-33 color-blue-dark d-block"></i>
							</div>
							<div class="align-self-center">
								<p class="color-blue-dark mb-0 font-500 font-14 ps-3 pe-4 line-height-s">
									Perhatian, Mohon Tunggu <br> Saat ini Sedang Mengirim OTP Ke Whatsapp Anda. 
								</p>
							</div>
						</div>
					</div>
				</div>
				
				<div v-show="!initial_send_otp">
					<p class="text-center font-16 mt-n2 mb-2">Verifikasi Akun</p>
					<p class="text-center font-13 mt-n2 mb-3">Silahkan Masukan Kode OTP</p>

					<div class="text-center mb-3 pt-3 pb-2">
						<!-- <form action=""> -->
							<input class="otp mx-1 text-center font-24 font-900" type="tel" v-model="otp[0]" @input="forceUpperCase($event, otp, '0')" :disabled="status_login">
							<input class="otp mx-1 text-center font-24 font-900" type="tel" v-model="otp[1]" @input="forceUpperCase($event, otp, '1')" :disabled="status_login">
							<input class="otp mx-1 text-center font-24 font-900" type="tel" v-model="otp[2]" @input="forceUpperCase($event, otp, '2')" :disabled="status_login">
							<input class="otp mx-1 text-center font-24 font-900" type="tel" v-model="otp[3]" @input="forceUpperCase($event, otp, '3')" :disabled="status_login">
							<input class="otp mx-1 text-center font-24 font-900" type="tel" v-model="otp[4]" @input="forceUpperCase($event, otp, '4')" :disabled="status_login">
							<input class="otp mx-1 text-center font-24 font-900" type="tel" v-model="otp[5]" @input="forceUpperCase($event, otp, '5')" :disabled="status_login">
							<!-- <input class="otp mx-1 text-center font-24 font-900" type="tel" v-model="otp[6]" @input="forceUpperCase($event, otp, '6')"> -->
						<!-- </form> -->
					</div>
					<button :disabled="status_login" @click="login" class='w-100 btn rounded-sm btn-m gradient-green text-uppercase font-700 mt-4 btn-full shadow-bg shadow-bg-s'>Verifikasi</button>
					<p class="pt-2 font-11 text-center pt-4">
                        Tidak menerima kode OTP Anda ? 
                        <a v-if="timeSendRepeat == 0" href="javascript:void(0)" @click="sendOtpFromApp">Kirim Ulang OTP</a>
                        <span v-else class="text-primary">{{ timeSendRepeat }}</span>
                    </p>
				</div>
			</div>
		</div>

		<Portal to="offcanvas-modal-bottom" :order="1">
            <!-- Share -->
            <!-- <a href="javascript:void(0)" ref="show-offcanvas-pkb-data" class="d-none" data-bs-toggle="offcanvas" data-bs-target="#offcanvas-pkb-data"></a> -->

            <div v-show="show_literacy_confirmed" :data-bs-scroll="!show_literacy_confirmed" data-bs-backdrop="false" class="offcanvas-custom offcanvas offcanvas-bottom rounded-m offcanvas-detached bg-theme show" style="visibility: visible;">
                <div class="content">
                    <div class="d-flex pb-2">
                        <div class="align-self-center">
							<h5 class="mb-n1 font-12 color-highlight font-700 text-uppercase pt-1">Terima Kasih</h5>
							<h1 class="font-700 font-20">Login Berhasil</h1>
						</div>
                        <div class="align-self-center ms-auto">
                            <a ref="hide-offcanvas-literacy-form" @click="hideLiteracyConfirmed" href="javascript:void(0)" class="icon icon-m"><i class="bi bi-x-circle-fill color-red-dark font-18 me-n4"></i></a>
                        </div>
                    </div>

                    <p>
						Silahkan klik tombol dibawah untuk melanjutkan.
					</p>
					<a href="javascript:void(0)" @click="hideLiteracyConfirmed" class='btn rounded-sm btn-m gradient-green text-uppercase font-700 mt-4 btn-full shadow-bg shadow-bg-s'>Lanjut</a>
                </div>
            </div>

            <div v-show="show_literacy_confirmed_backdrop" class="offcanvas-backdrop fade show"></div>
        </Portal>

    </div>
	<!-- End of Page Content-->
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'

export default {
    name: 'LoginOtp',
    data() {
        return {
            timeSendRepeat: 30,
			initial_send_otp : false,
			otp: [null, null, null, null, null, null],
			status_login: false,
			show_literacy_confirmed: false,
            show_literacy_confirmed_backdrop: false,
		}
    },
	created() {
        this.countDownTimer()

		if (this.isAuth) {
			this.$router.push({name: 'home'})
		}
	},
    mounted() {
		this.$nextTick(function () {
			// do stuff with the DOM
			document.refreshEventKeyUpOtp()
		})
	},
	computed: {
		...mapGetters(['isAuth']),
		...mapState(['errors']),
	},
	methods: {
		...mapActions('otp', ['sendOtp', 'verfiyOtp']),
		...mapMutations(['CLEAR_ERRORS']),
		async sendOtpFromApp() {
            this.timeSendRepeat = 30
			this.initial_send_otp = true
			await this.sendOtp(this.$route.query.nisn)
			this.initial_send_otp = false
            this.countDownTimer()
		},
		login() {
			this.status_login = true
			let form_verify_otp = {
				otp: this.otp.join('')
			}
			this.verfiyOtp(form_verify_otp)
				.then(() => {
					this.showLiteracyConfirmed()
					
					this.status_login = false
				})
				.catch(() => {
					this.status_login = false
				})
		},
		showLiteracyConfirmed() {
            this.show_literacy_confirmed = true
            this.show_literacy_confirmed_backdrop = true
        },
        hideLiteracyConfirmed() {
            this.show_literacy_confirmed = false
            this.show_literacy_confirmed_backdrop = false

			if (this.isAuth) {
				this.CLEAR_ERRORS()
				this.$router.push({ name: 'home' })
			}
        },
		forceUpperCase(e, o, prop) {
			const start = e.target.selectionStart;
			e.target.value = e.target.value.toUpperCase();
			this.$set(o, prop, e.target.value);
			e.target.setSelectionRange(start, start);
		},
        countDownTimer () {
            if (this.timeSendRepeat > 0) {
                setTimeout(() => {
                    this.timeSendRepeat -= 1
                    this.countDownTimer()
                }, 1000)
            }
        }
	},
}
</script>